import $ from "jquery";
import "slick-carousel";
// banner slider js
$(".single-item").slick({
	dots: true,
	autoplay: true,
	autoplaySpeed: 10000,
	responsive: [
		{
			breakpoint: 480,
			settings: {
				centerMode: true,
				centerPadding: false,
				slidesToShow: 1,
				arrows: false,
				autoplay: true,
				autoplaySpeed: 10000,
			},
		},
	],
});
// banner slider js
$("#simple-banner-slider").slick({
	dots: false,
	arrows: true,
	autoplay: true,
	autoplaySpeed: 10000,
});

// review slider js
$(".review-slider").slick({
	infinite: true,
	lazyLoad: "ondemand",
	slidesToShow: 3,
	slidesToScroll: 3,
	autoplay: true,
	autoplaySpeed: 10000,
	responsive: [
		{
			breakpoint: 480,
			settings: {
				centerMode: true,
				centerPadding: false,
				slidesToShow: 1,
			},
		},
	],
});

// review world image slider js
$(".world-image-slider").slick({
	infinite: true,
	lazyLoad: "ondemand",
	slidesToShow: 5,
	slidesToScroll: 5,
	dots: true,
	autoplay: true,
	autoplaySpeed: 10000,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				centerMode: true,
				centerPadding: false,
				slidesToShow: 3,
				arrows: false,
			},
		},
		{
			breakpoint: 480,
			settings: {
				centerMode: true,
				centerPadding: false,
				slidesToShow: 1,
				arrows: false,
			},
		},
	],
});

// suggested blogs slider js
$(".suggested-blogs-slider").slick({
	infinite: true,
	centerMode: true,
	centerPadding: "360px",
	dots: false,
	slidesToShow: 2,
	autoplay: true,
	autoplaySpeed: 10000,
	responsive: [
		{
			breakpoint: 1366 + 1,
			settings: {
				centerMode: true,
				centerPadding: "140px",
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 1024 + 1,
			settings: {
				centerMode: true,
				centerPadding: "40px",
				slidesToShow: 2,
			},
		},
		{
			breakpoint: 768,
			settings: {
				arrows: false,
				centerMode: true,
				centerPadding: "10px",
				slidesToShow: 1,
				dots: true,
			},
		},
		{
			breakpoint: 480,
			settings: {
				arrows: false,
				centerMode: true,
				centerPadding: false,
				slidesToShow: 1,
				dots: true,
			},
		},
	],
});
